import * as pinia from 'pinia';
import { computed } from 'vue';
import ChatService from '@/Services/ChatService';
import useSessionStore from '@/Stores/useSessionStore';
import { phasesData } from '@/Utils/configs';
import { USER_ROLE } from '@/Utils/vice-constants';

const sessionStore = useSessionStore();
const userType = computed(() => {
  if (sessionStore.userIsObserver) return USER_ROLE.OBSERVER;
  if (sessionStore.isClinician) {
    return USER_ROLE.CLINICIAN;
  }
  return USER_ROLE.PARTICIPANT;
});

const useChatMessagesStore = pinia.defineStore('ChatMessagesStore', {
  state: () => ({ chatMessages: [] }),
  getters: {
    allChatMessages: (state) => state.chatMessages,
  },
  actions: {
    addChatMessage(messagePayload) {
      this.allChatMessages.push(messagePayload);
    },

    async sendChatMessage(chatData) {
      const senderInfo = {
        id: sessionStore.authUser.id,
        name: sessionStore.authUser?.name,
        type: userType.value,
        avatar: sessionStore.authUser?.profile_photo_url,
      };

      const phaseInfo = {
        id: sessionStore.currentPhase,
        type: phasesData?.[sessionStore.currentPhase]?.title,
      };

      const payload = {
        ...chatData,
        sentAt: new Date(),
        handledAt: null,
        sender: JSON.stringify(senderInfo),
        phase: JSON.stringify(phaseInfo),
      };

      sessionStore.jitsiCommands.sendViceMessage(payload);

      // Send message to smart glass
      if (chatData.sendTo === USER_ROLE.CLINICIAN && chatData.type === 'message') {
        sessionStore.deviceMessageSender.sendSmartGlassTextMessage({
          ...chatData,
          deviceMessageType: 'MESSAGE',
          phaseInfo,
          senderInfo,
          sentAt: payload.sentAt,
          handledAt: payload.handledAt,
        });
      }

      // Persist Data
      try {
        const messagePayload = {
          ...payload,
          sender: senderInfo,
          phase: phaseInfo,
          attachment: payload.attachment ? JSON.parse(payload.attachment) : null,
        };
        await ChatService.addNewMessage(sessionStore.sessionUniqueId, messagePayload);
      } catch (error) {
        console.error(error);
      }
    },
  },
});

export default useChatMessagesStore;
